import { Component, OnInit } from '@angular/core';
import { ModalController, LoadingController } from '@ionic/angular';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalService } from '../global.service';
import { resolve } from 'q';
import { map, catchError } from 'rxjs/operators';
@Component({
  selector: 'app-select-weapons',
  templateUrl: './select-weapons.page.html',
  styleUrls: ['./select-weapons.page.scss'],
})
export class SelectWeaponsPage implements OnInit {

    dataset = null;
    constructor(private modalController: ModalController, public http: HttpClient, private globalService: GlobalService,private loadingController:LoadingController) { }

    close() {
        this.modalController.dismiss();
    }
    ngOnInit() {
        if (GlobalService.JSON_WEAPONS == null) {
            this.load();
        }
        else {
            this.dataset = GlobalService.JSON_WEAPONS;
        }
  }
    select(item) {
        this.modalController.dismiss(item);
    }
    async load() {
        const loading = await this.loadingController.create({
            message: '',
            spinner: 'crescent'
        });
        await loading.present();
        return new Promise(resolve => {
            this.http.get("./../assets/data/weapons.json").
                pipe(map(
                    (response) => JSON.parse(JSON.stringify(response))
                )).
                subscribe(
                    (data) => {
                        {
                            console.log(data);
                            loading.dismiss();
                            this.dataset = data;
                            GlobalService.JSON_WEAPONS = data;
                            resolve(this.dataset);
                        }
                    }
                )

        });
    }

    

}
